// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {buildWipOpenPipCount, getWipPipsIndicator} from '../shared/services/home-page-helper';
import Accordion from '../../shared/components/accordion';
import WipPipItem from './wip-item';
import wipOpenPip from '@deere/cps-it.warranty-model-factory/lib/open-pips-summary';

const WipPips = props => {

    const accordionTitle = (
        <WipPipItem
            className={getWipPipsIndicator(props.wipOpenPip)}
            count={buildWipOpenPipCount(props.wipOpenPip)}
            status='OPEN_PIPS'
        />
    );

    const accordionBody = (
        <div>
            <WipPipItem
                className={props.wipOpenPip.expiredCount ? 'dot-icon-red' : ''}
                count={props.wipOpenPip.expiredCount}
                status='EXPIRED'
            />
            <WipPipItem
                className={props.wipOpenPip.pinsExpiringInNext90Days ? 'dot-icon-yellow' : ''}
                count={props.wipOpenPip.pinsExpiringInNext90Days}
                status='EXPIRING_SOON'
            />
            <WipPipItem
                className=''
                count={props.wipOpenPip.currentPinsCount}
                status='CURRENT'
            />
        </div>
    );

    return (
        <Accordion
            accordionId='pip-indicators'
            body={accordionBody}
            title={accordionTitle}
        />
    );

};

WipPips.displayName = 'WipPips';
WipPips.propTypes = {
    wipOpenPip: PropTypes.instanceOf(wipOpenPip).isRequired
};

export default WipPips;



// WEBPACK FOOTER //
// ./src/home-page/components/wip-pips.js